import FormsyInput from 'shared/components/Textfield'
import Textarea from 'shared/components/Textarea'

import styles from '../styles.module.scss'

const ThankYouModalContent = ({
    translationType,
    imgUrl,
    onChange,
    prefix,
    formData,
    setShowError,
    onChangeHandlerTextarea,
}) => (
    <>
        <h2 className="text-center">
            <T values={{ translationType: translationType }}>nps.admin.create.new.survey.thank.you.msg.title</T>
        </h2>
        <div className={styles.thankYouContent}>
            <div className="d-flex flex-column">
                <span className="text-large">
                    <T>nps.admin.create.new.survey.thank.you.title</T>
                </span>
                <FormsyInput
                    required
                    name={`${prefix}thankYouTitle`}
                    onChange={onChange}
                    value={formData[`${prefix}thankYouTitle`] || ''}
                    setShowError={setShowError}
                />
                <span className="text-large mt-2">
                    <T>nps.admin.create.new.survey.thank.you.desc</T>
                </span>
                <Textarea
                    required
                    name={`${prefix}thankYouBody`}
                    value={formData[`${prefix}thankYouBody`] || ''}
                    onChange={e => onChangeHandlerTextarea(e, prefix)}
                    setShowError={setShowError}
                    rows="3"
                    textareaClassName={styles.thankBodyText}
                />
            </div>
            <div className={styles.imgThankYouWrap}>
                <img src={imgUrl} alt="Thank you modal example" />
            </div>
        </div>
    </>
)

export default ThankYouModalContent
